import { useState } from 'react';
import { StatusUpdateContext, useDataRequestContext } from '@vivli/features/data-requests/infrastructure/context';
import { IContextWrapper, IStatusUpdate } from '@vivli/shared/infrastructure/interface';
import { UseFormReturn } from 'react-hook-form';
import { IDataRequest } from '@vivli/features/data-requests/infrastructure/interface';
import { first } from 'rxjs/operators';
import { useDataRequestsApiContext, useModalApiContext, useToastApiContext } from '@vivli/core/infrastructure/context';
import { useFormDirtyTracking } from '@vivli/shared/infrastructure/hook';

export const StatusUpdateContextWrapper = ({ children }: IContextWrapper) => {
    const { updateDataRequest, dataRequest } = useDataRequestContext();
    const toastService = useToastApiContext();
    const modalService = useModalApiContext();
    const dataRequestService = useDataRequestsApiContext();

    const [isSubmittingForm, setIsSubmittingForm] = useState(false);
    const [formApi, setFormApi] = useState<UseFormReturn<IStatusUpdate>>();

    //TODO - use form-api state as source of truth instead of this hook
    const { isFormDirty, resetBaseline } = useFormDirtyTracking(formApi);

    const handleSuccess = (_dataRequest: IDataRequest) => {
        updateDataRequest(_dataRequest);
        toastService.success('Successfully saved your Status Update');
        setIsSubmittingForm(false);
        formApi?.reset(_dataRequest.statusUpdate, { keepErrors: true, keepIsValid: true });
        resetBaseline();
    };

    const handleFailure = (err: string) => {
        modalService.error(`An error occurred submitting your status update. Please try again or contact Vivli support. Message: ${err}`);
        setIsSubmittingForm(false);
    };

    const submitStatusUpdate = () => {
        setIsSubmittingForm(true);
        const statusUpdate: IStatusUpdate = formApi.getValues();

        //we have to add the field that appears in the DUA tab, and isn't
        //part of this form: DUAStatus. otherwise
        //any changes to DUAStatus since we loaded the status update form
        //will be lost.
        statusUpdate.duaStatus = dataRequest?.statusUpdate?.duaStatus;
        dataRequestService.postStatusUpdate(dataRequest.id, statusUpdate).pipe(first()).subscribe(handleSuccess, handleFailure);
    };

    const provider = {
        submitStatusUpdate,
        isSubmittingForm,
        formApi,
        setFormApi,
        isFormDirty
    };

    return (
        <StatusUpdateContext.Provider value={provider}>
            <div style={{ height: '100%', width: '100%' }}>{children}</div>
        </StatusUpdateContext.Provider>
    );
};
